// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    header: {
                        text: "Share a cart with friends, shop together, deliver to one address, and enjoy group discounts."
                    },
                    signup: {
                        cancel: "Close Crewcart",
                        subText: "back to single shopping",
                    },
                    info: {
                        title: "How does Crewcart work?",
                        description: "Enter your name and email, then share the link with your friends.\n\n" +
                            "Your friends can add items to the shared basket, so everyone benefits from ordering together.\n\n" +
                            "Once the basket is ready, one person checks out and decides where the order will be delivered.\n\n" +
                            "We'll send the order details, so everyone knows who owes what and who ordered which items.\n\n" +
                            "The entire order is sent to the chosen address, and you handle distributing the items among your friends.\n\n",
                        discover: "Discover more at",
                    },
                    leaveConfirmation: {
                        title: "Are you sure you wish to leave the crewcart?",
                        message: "Your items will be removed from the crewcart, but will remain available in your personal cart.",
                        confirmButton: "Yes, Leave Crewcart",
                        cancelButton: "No, Stay"
                    },
                    createCrewcart: {
                        nameRequired: "Please enter your name",
                        join: "Join Crewcart",
                        welcome: "Welcome to the",
                        enterName: "Please enter your name and email address to start shopping!",
                        shareCrewcart: "Share a cart with friends, shop together, deliver to one address, and enjoy group discounts.",
                        ofCrewcart: "of crewcart",
                        name: "Your name",
                        email: "Your email",
                        create: "Create Crewcart",
                        crewcartName: "Name of your crewcart",
                        terms: "I accept the",
                        startShopping: "Start Shopping Together",
                        learnMore: "Learn more about Crewcart",
                        termsText: "Terms",
                    },
                    cartItems: {
                        doneShoppingInfo: "Let your friends know you're done shopping and wait for the last shopper to checkout for your crew.",
                        leave: "Leave",
                        leaveCrewcart: "leave this crewcart",
                        leaveConfirm: "Are you sure? click again to confirm.",
                        share: "Share",
                        shareCrewcart: "Share this crewcart",
                        shareSuccess: "Crewcart shared successfully",
                        shareError: "Error sharing crewcart",
                        shareBox: "Share with your friends & family",
                        shareDescription: "Share the link with friends to automatically add their items to your shared cart",
                        doneShopping: "Done Shopping",
                        continueShopping: "Not done yet?, Continue Shopping",
                        totalDiscount: "Total Discount Earned",
                        total: "Total",
                        copied: "Copied!",
                        checkout: "Checkout",
                        crewcartClosed: "This crewcart is currently being checked out and cannot be joined. Please try again later.",
                    },
                    removedUser: {
                        title: "Removed from the crewcart",
                        description: "Because you were not ready, your items have been removed from the crewcart. Don't worry! They will remain available in your personal cart.",
                        close: "Close"
                    },
                    confirmDeletePendingUser: {
                        title: "Confirm Checkout",
                        newDescription: "Select which members to include in the checkout. Unchecked members will be removed from the crewcart.",
                        add: "Member",
                        removalWarning: "{{members}} members and {{items}} items will be removed from the crewcart",
                        cancel: "Cancel",
                        checkout: "Checkout",
                        membersReady: "Members Ready for Order",
                        membersNotReady: "Members Not Ready"
                    },
                    overview: {
                        cancelCheckout: "Cancel Checkout",
                        continueShopping: "Continue Shopping",
                        subText: "Complete the checkout to pay for the entire Crewcart.\n" +
                            "All items will be shipped to your address, and we'll provide a detailed\n" +
                            "breakdown to help you split costs with your friends.",
                        name: "Shoppers",
                        totalItems: "Items",
                        price: "Price",
                        total: "Total",
                        wait: "Waiting for all members to complete",
                        checkoutInProgress: "Checkout in progress by",
                        hold: "hold tight!",
                    },
                    tabs: {
                        crewcart: "Crewcart",
                        cartOverview: "Overview",
                        info: "Info",
                    }
                }
            },
            nl: {
                translation: {
                    header: {
                        text: "Deel een winkelwagen met vrienden, shop samen, laat bezorgen op één adres en profiteer van groepskortingen."
                    },
                    signup: {
                        cancel: "Crewcart sluiten",
                        subText: "terug naar individueel winkelen",
                    },
                    leaveConfirmation: {
                        title: "Weet je zeker dat je de crewcart wilt verlaten?",
                        message: "Je items worden verwijderd uit de crewcart, maar blijven beschikbaar in je persoonlijke winkelwagen.",
                        confirmButton: "Ja, verlaat Crewcart",
                        cancelButton: "Nee, blijf"
                    },
                    info: {
                        title: "Hoe werkt Crewcart?",
                        description: "Voer je naam en e-mail in en deel vervolgens de link met je vrienden.\n\n" +
                            "Je vrienden kunnen items toevoegen aan de gedeelde winkelmand, zodat iedereen profiteert van samen bestellen.\n\n" +
                            "Zodra de winkelmand klaar is, rekent één persoon af en bepaalt waar de bestelling wordt bezorgd.\n\n" +
                            "We sturen de bestelgegevens, zodat iedereen weet wie wat moet betalen en wie welke items heeft besteld.\n\n" +
                            "De volledige bestelling wordt naar het gekozen adres verzonden en jij regelt de verdeling van de items onder je vrienden.\n\n",
                        discover: "Ontdek meer op"
                    },
                    createCrewcart: {
                        nameRequired: "Naam is een verplicht veld",
                        join: "Crewcart Joinen",
                        welcome: "Welkom bij Crewcart",
                        enterName: "Voer je naam en e-mailadres in om te beginnen met winkelen!",
                        shareCrewcart: "Deel een winkelwagen met je vrienden, shop samen, bestel op één adres en geniet van groepskortingen.",
                        ofCrewcart: "van crewcart",
                        name: "Jouw naam",
                        email: "Jouw e-mail",
                        create: "Crewcart aanmaken",
                        crewcartName: "Naam van je Crewcart",
                        terms: "Ik accepteer de",
                        startShopping: "Begin met samen shoppen",
                        learnMore: "Meer informatie over Crewcart",
                        termsText: "Voorwaarden",
                    },
                    cartItems: {
                        doneShoppingInfo: "Laat je vrienden weten dat je klaar bent met winkelen en wacht tot de laatste shopper afrekent voor je crew.",
                        leave: "Verlaten",
                        leaveCrewcart: "verlaat deze crewcart",
                        leaveConfirm: "Weet je het zeker? klik nogmaals om te bevestigen.",
                        share: "Delen",
                        shareCrewcart: "Deel deze crewcart",
                        shareSuccess: "Crewcart succesvol gedeeld",
                        shareError: "Fout bij delen van crewcart",
                        shareBox: "Deel met je vrienden & familie",
                        shareDescription: "Deel de link met je vrienden, en alle items die zij toevoegen verschijnen automatisch in je gedeelde winkelwagen",
                        doneShopping: "Klaar met shoppen",
                        continueShopping: "Nog niet klaar?, klik om verder te shoppen!",
                        totalDiscount: "Totale korting verdiend",
                        total: "Totaal",
                        copied: "Gekopieerd!",
                        checkout: "Afrekenen",
                        crewcartClosed: "Deze crewcart wordt momenteel afgerekend en kan niet worden gekoppeld. Probeer het later opnieuw.",
                    },
                    confirmDeletePendingUser: {
                        title: "Bevestig Crewleden",
                        newDescription: "De volgende crewleden hebben nog artikelen in hun winkelwagen en hebben hun selectie niet bevestigd. Vink alle leden aan die u in de crewcart wilt behouden tijdens het afrekenen.",
                        add: "Toevoegen",
                        removalWarning: "{{members}} leden en {{items}} artikelen worden verwijderd uit de crewcart",
                        cancel: "Annuleren",
                        checkout: "Doorgaan naar Afrekenen",
                        membersReady: "Leden klaar voor bestelling",
                        membersNotReady: "Leden nog niet klaar"
                    },
                    overview: {
                        continueShopping: "Verder winkelen",
                        cancelCheckout: "Afrekenen annuleren",
                        subText: "Betaal voor de hele Crewcart, ontvang alle artikelen op jouw adres en krijg een overzicht om de kosten makkelijk te verdelen.",
                        name: "Shoppers",
                        totalItems: "Items",
                        price: "Prijs",
                        total: "Totaal",
                        wait: "Wachten tot alle leden klaar zijn",
                        checkoutInProgress: "Er wordt afgerekend door",
                        hold: "even geduld!",
                    },
                    tabs: {
                        crewcart: "Crewcart",
                        cartOverview: "Overzicht",
                        info: "Info",
                    },
                    removedUser: {
                        title: "Verwijderd uit de crewcart",
                        description: "Omdat je niet klaar was, zijn je items verwijderd uit de crewcart. Maak je geen zorgen! Ze blijven beschikbaar in je persoonlijke winkelwagen.",
                        close: "Sluiten"
                    }
                }
            },
            fr: {
                translation: {
                    header: {
                        text: "Partagez un panier avec vos amis, faites vos achats ensemble, livrez à une adresse et profitez des réductions de groupe."
                    },
                    signup: {
                        cancel: "Fermer Crewcart",
                        subText: "retour aux achats individuels",
                    },
                    leaveConfirmation: {
                        title: "Êtes-vous sûr de vouloir quitter le crewcart ?",
                        message: "Vos articles seront retirés du crewcart, mais resteront disponibles dans votre panier personnel.",
                        confirmButton: "Oui, quitter Crewcart",
                        cancelButton: "Non, rester"
                    },
                    info: {
                        title: "Comment fonctionne Crewcart ?",
                        description: "Entrez votre nom et votre e-mail, puis partagez le lien avec vos amis.\n\n" +
                            "Vos amis peuvent ajouter des articles au panier partagé, afin que tout le monde profite de la commande groupée.\n\n" +
                            "Une fois le panier prêt, une personne passe la commande et choisit l'adresse de livraison.\n\n" +
                            "Nous envoyons les détails de la commande, afin que chacun sache qui doit payer quoi et quels articles ont été commandés.\n\n" +
                            "La commande complète est envoyée à l'adresse choisie, et vous vous occupez de la distribution des articles entre vos amis.\n\n",
                        discover: "Découvrez plus sur"
                    },
                    createCrewcart: {
                        join: "joindre le Crewcart",
                        welcome: "Bienvenue sur",
                        enterName: "Entrez votre nom et email pour commencer vos achats !",
                        shareCrewcart: "Partagez un panier avec vos amis, achetez ensemble, livrez à une adresse et profitez des réductions de groupe.",
                        name: "Votre nom",
                        ofCrewcart: "de crewcart",
                        email: "Votre email",
                        create: "Créer Crewcart",
                        crewcartName: "Nom de votre crewcart",
                        terms: "J'accepte les",
                        startShopping: "Commencer les achats en groupe",
                        learnMore: "En savoir plus sur Crewcart",
                        termsText: "Conditions",
                    },
                    cartItems: {
                        doneShoppingInfo: "Informez vos amis que vous avez terminé vos achats et attendez que le dernier acheteur passe à la caisse pour votre équipe.",
                        leave: "Quitter",
                        leaveCrewcart: "quitter ce crewcart",
                        leaveConfirm: "Êtes-vous sûr ? cliquez à nouveau pour confirmer.",
                        share: "Partager",
                        shareCrewcart: "Partager ce crewcart",
                        shareSuccess: "Crewcart partagé avec succès",
                        shareError: "Erreur lors du partage de Crewcart",
                        shareBox: "Partagez avec vos amis & famille",
                        shareDescription: "Partagez le lien avec vos amis - leurs articles apparaîtront automatiquement dans votre panier partagé",
                        doneShopping: "Achats terminés",
                        totalDiscount: "Réduction totale obtenue",
                        total: "Total",
                        continueShopping: "Pas encore terminé ? cliquez ici",
                        copied: "Copié !",
                        checkout: "Paiement",
                        crewcartClosed: "Cette crewcart est en cours de réglement et ne peut être jointe. Veuillez réessayer plus tard.",
                    },
                    confirmDeletePendingUser: {
                        title: "Confirmer les Membres d'Équipage",
                        newDescription: "Les membres d'équipage suivants ont encore des articles dans leur panier et n'ont pas confirmé leur sélection. Veuillez cocher tous les membres que vous souhaitez conserver dans le crewcart lors du paiement.",
                        add: "Ajouter",
                        removalWarning: "{{members}} membres et {{items}} articles seront supprimés du crewcart",
                        cancel: "Annuler",
                        checkout: "Continuer vers le Paiement",
                        membersReady: "Membres prêts pour la commande",
                        membersNotReady: "Membres pas encore prêts"
                    },
                    overview: {
                        continueShopping: "Continuer les achats",
                        cancelCheckout: "Annuler le paiement",
                        subText: "Terminez votre commande pour payer l'ensemble du Crewcart.\n" +
                            "Tous les articles seront expédiés à votre adresse et nous vous fournirons un décompte détaillé pour vous aider à partager les coûts avec vos amis.\n" +
                            "détaillée pour vous aider à partager les coûts avec vos amis.",
                        name: "Acheteurs",
                        totalItems: "Articles",
                        price: "Prix",
                        total: "Total",
                        wait: "En attente que tous les membres terminent",
                        checkoutInProgress: "Paiement en cours par",
                        hold: "Veuillez patienter !",
                    },
                    tabs: {
                        crewcart: "Crewcart",
                        cartOverview: "Aperçu",
                        info: "Info",
                    },
                    removedUser: {
                        title: "Retiré du crewcart",
                        description: "Parce que vous n'étiez pas prêt, vos articles ont été retirés du crewcart. Ne vous inquiétez pas ! Ils resteront disponibles dans votre panier personnel.",
                        close: "Fermer"
                    }
                }
            }
        },
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
